var n=function(n){void 0===n&&(n=[]);var o=new URL(window.location.href);n.forEach((function(n){var r=n.name,a=n.value;return o.searchParams.set(r,a)})),window.location.href=o.toString()};export{n as setUrlWithParams};
//# sourceMappingURL=setUrlWithParams.js.map
